var _path, _circle;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLockCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 18H28V16C28 13.24 25.76 11 23 11C20.24 11 18 13.24 18 16V18H17C15.9 18 15 18.9 15 20V30C15 31.1 15.9 32 17 32H29C30.1 32 31 31.1 31 30V20C31 18.9 30.1 18 29 18ZM19.9 16C19.9 14.29 21.29 12.9 23 12.9C24.71 12.9 26.1 14.29 26.1 16V18H19.9V16ZM27 26H24V29H22V26H19V24H22V21H24V24H27V26Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircle);
export default __webpack_public_path__ + "static/media/lockCircle.32eb14da8a037c7d1b870803a23ba0d8.svg";
export { ForwardRef as ReactComponent };